import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-pagenotfound',
    imports: [MatButtonModule, RouterModule],
    standalone: true,
    templateUrl: './pagenotfound.component.html',
    styleUrl: './pagenotfound.component.scss'
})
export class PageNotFoundComponent {
  pageX: number = 0
  pageY: number = 0
  
  @ViewChild('eyes') eyes!: ElementRef
  
  ngAfterViewInit() {
  }

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      // No estamos en navegador, ignorar
      return;
    }

    // Asegurarnos de que el elemento existe
    if (!this.eyes || !this.eyes.nativeElement) {
      return;
    }
    
    this.pageX = window.innerWidth
    this.pageY = window.innerHeight

    const mouseY = event.pageY;
    const mouseX = event.pageX / -this.pageX;

    // Replicating the same calculations from the original jQuery code
    const yAxis = (this.pageY / 2 - mouseY) / this.pageY * 300; // Vertical movement
    const xAxis = -mouseX * 100 - 100;

    // Update the transform style of the eyes
    this.eyes.nativeElement.style.transform = `translate(${xAxis}%, -${yAxis}%)`
  }
}
